module.exports = __webpack_public_path__ + "static/parade-2020-house23-62a2fdd5c0bc683e9a04f97a3d1a549d.jpg";